import React, { useState } from "react";
import { ReactComponent as Arrow } from "../../../assets/novosicones/Financeiro/expand_more_black_24dp.svg";
const Alert = () => {
  const [showPagasFooter, setShowPagasFooter] = useState(true);

  const handleShowPagasFooter = () => {
    setShowPagasFooter(!showPagasFooter);
  };

  const estiloFooterVisible = {
    height: "auto",
    overflow: "visible",
    padding: "0 8px",
  };
  const estiloFooterHidden = {
    height: "0px",
    overflow: "hidden",
    padding: "0 8px",
  };

  const estiloContainer = {
    width: "100%",
    textAlign: "left",
    marginTop: "25px",
    border: "2px solid #d1d1d1",
  };

  return (
    <div style={estiloContainer}>
      <div
        className="centralized-space-between "
        onClick={handleShowPagasFooter}
        style={
          showPagasFooter
            ? { borderBottom: "2px solid #d1d1d1" }
            : { borderBottom: "none" }
        }
      >
        <p style={{ color: "#4d4d4d", padding: "8px", margin: "0" }}>
          Legenda e notas de atenção
        </p>
        <Arrow
          style={
            showPagasFooter
              ? { transform: "rotate(-180deg)" }
              : { transform: "rotate(0deg)" }
          }
        />
      </div>
      <div style={showPagasFooter ? estiloFooterVisible : estiloFooterHidden}>
        <span>
          <b style={{ color: "#ba122b", margin: "8px 0", display: "block" }}>
            Atenção:
          </b>
        </span>
        <p style={{ fontSize: "14px", margin: "10px 0" }}>
          - Por aqui, você consulta boletos de parcelas com pagamento aprovado.
          Após pagar o boleto, o prazo para a sua compensação é de até 3 dias
          úteis. Isso acontece porque os bancos precisam repassar o valor pago
          para a instituição que deve receber.
        </p>
      </div>
    </div>
  );
};

export default Alert;
